const ErrorParser = (err: any, navigate: any) => {
  if (err?.status === 404) {
    navigate("/error/page-not-found", { state: err, replace: true });
  } else if (err?.status === 401) {
    navigate("/error/forbidden", { state: err });
  } else navigate("/error/service-unavailable", { state: err, replace: true });
};

export default ErrorParser;
